import classnames from 'classnames';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import TagModel from '@mm/state/model/TagModel';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { AccordionItem } from '@mm/components';
import { AssignTagForm } from '../../../AssignTagForm/AssignTagForm';
import './chatVariablesTags.pcss';
import { TagFilled } from '@ant-design/icons';
import { Spin, Tag } from 'antd';
import { useTagsCRUDActions } from '@mm/state/actions/TagsCRUDActions';
import { SelectedContact } from '@mm/state/interfaces/contacts';

type Props = {
  contactId: number;
  selectedContact?: SelectedContact;
  tags: TagModel[];
  isLiveChatContacts?: boolean;
  onChange?: (busyComponent?: string) => void;
  collapsedContactView?: boolean;
  busy?: string[];
};

export const ChatVariablesTags = ({
  tags,
  contactId,
  selectedContact,
  onChange,
  isLiveChatContacts = false,
  collapsedContactView,
  busy,
}: Props) => {
  const fbPageId = useSelector(activeFacebookPageIdSelector);
  const { unassign } = useTagsCRUDActions();
  const tagsBusyName = 'tags';
  const isDummyContact = selectedContact?.dummy;

  const onChangeTags = useCallback(async () => {
    if (isDummyContact) return;
    onChange?.(tagsBusyName);
  }, [isDummyContact, onChange]);

  const onTagRemove = async (item: TagModel) => {
    await unassign(
      item.name || '',
      item.kind || undefined,
      fbPageId,
      contactId,
    );
    onChangeTags();
  };

  const tagsWrapperClasses = classnames('contact-tags__wr', {
    'live-chat--contact-tags__wr': isLiveChatContacts,
  });

  if (collapsedContactView) {
    return (
      <div className="live-chat--contact__header--collapsed">
        <TagFilled className="contact-details__header-icon" />
        <span className="live-chat--contact__content-number--collapsed">
          ({tags.length})
        </span>
      </div>
    );
  }

  return (
    <div className={tagsWrapperClasses}>
      <AccordionItem
        icon={<TagFilled className="contact-details__nested-header-icon" />}
        title="Tags"
        count={tags.length}
        closeOnOutsideClick={false}
        className="contact-details__nested-accordion-item"
        headingClassName="contact-details__accordion-item-heading"
        openOnMount={!!tags.length}
        withBorder={false}
      >
        <div className="contact-tags__content">
          <AssignTagForm
            contactId={contactId}
            tags={tags}
            disabled={isDummyContact}
            fbPageId={fbPageId}
            onChange={onChangeTags}
          />

          <div className="contact-tags__list">
            <Spin
              size="small"
              spinning={busy?.includes(tagsBusyName)}
              style={{ marginRight: '8px' }}
            />
            {tags.map(tag => (
              <Tag
                key={tag.name}
                color="geekblue"
                onClose={() => onTagRemove(tag)}
                closable={tag.kind !== 'service'}
              >
                {tag.name}
              </Tag>
            ))}
          </div>
        </div>
      </AccordionItem>
    </div>
  );
};
